export const QuestionTypes = {
  Text: 1,
  Numeric: 2,
  Multiple_Choice: 3,
  Dropdown: 4,
  Date: 5,
  Time: 6,
  Matrix: 7,
  Numeric_Tally: 8,
  Picklist: 9,
  Info: 10,
  Scale: 11,
  Video: 12,
  Identifier: 13,
  Institution: 14,
  Checkbox: 15,
  Textarea: 16
};

export const WidgetTypes = {
  Qualtrics: 1,
  QA: 2,
  Tabs: 3,
  DataTable: 4,
  Filter: 5,
  Row: 6,
  Info: 7,
  Identifier: 8,
  REDCapForm: 9,
  DisplayEditInfo: 11,
  Button: 12,
  Randomize : 13,
  DataElement: 14,
  Video: 15,
  MDHData: 16
};
